// import TonaleImg from "../../assets/img/AR-Menu-Tonale_Ti.png";
import GiuliaImg from "../../assets/img/AR-Menu-GIULIA-MCA-TI.png";
import GiuliaQVImg from "../../assets/img/Giulia-QV-MCA.png";
import JuniorHImg from "../../assets/img/Junior-H.png";
import JuniorEImg from "../../assets/img/Junior-E.png";
import StelvioImg from "../../assets/img/AR-Menu-Stelvio-MCA-TI.png";
import StelvioQVImg from "../../assets/img/Stelvio-QV-MCA.png";
// import TonaleHImg from "../../assets/img/AR-MILANO-TRIM_Veloce_Grey.png";
import NewTonale from "../../assets/img/Tonale_MCA_Speciale Sport_Plug In.png";

export const vehicleImages: Record<string, string> = {
  // Tonale: TonaleImg,
  Tonale: NewTonale,
  Giulia: GiuliaImg,
  "Giulia Quadrifoglio": GiuliaQVImg,
  "Junior Ibrida": JuniorHImg,
  "Junior Elettica": JuniorEImg,
  Stelvio: StelvioImg,
  "Stelvio Quadrifoglio": StelvioQVImg,
  // "Tonale Plug-in Hybrid": TonaleHImg,
  "Novi Tonale diesel": NewTonale,
  "Novi Tonale MHEV": NewTonale,
};

// offer
export const imagesOrder = [
  "Junior Ibrida",
  "Junior Elettica",
  "Tonale",
  "Novi Tonale diesel",
  "Novi Tonale MHEV",
  "Stelvio",
  "Stelvio Quadrifoglio",
  "Giulia",
  "Giulia Quadrifoglio",
];

// test drive
export const imagesOrderTestDrive = [
  "Junior Ibrida",
  "Novi Tonale MHEV",
  "Stelvio",
];

// stari poredak
// export const imagesOrder = [
//   "Tonale",
//   "Giulia",
//   "Giulia Quadrifoglio",
//   "Junior Ibrida",
//   "Junior Elettica",
//   "Stelvio",
//   "Stelvio Quadrifoglio",
//   // "Tonale Plug-in Hybrid",
//   "Novi Tonale diesel",
//   "Novi Tonale MHEV",
// ];
